module.exports = __webpack_public_path__ + "static/media/pointing_hand.9e5ce03c.svg";